var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5440_45544",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5440_45544",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACIElEQVRo3u2avU7CUBTHO8BEGOTjDfArMTKAwEOABDZDQDC+AOxMmKCzIxhfoFB9BF00KhgWDIQNdGBTKAlCUs8lJTa1Qgu9bS96kt8CDP/fpZ/nXIr6r+/iOM4C+IADIA1kedL8Z+g7i2ECb9BJ6q5bd0OoHPAIjLj5NeJ/mxu/3br7l07tg2+WkyYgAVTOX664RWtYPeN6RVsFiAMm7MFddAKFDwNNgEOoIDClAYR7BTu2VXcApWlwDAJTSoBD7fA+oC0Oj0kA0QZ8aoUPAQOp8BgFECwQVCP852/hMQsghgtLQDj/rJXXSAAxUHw4QTAn0JkXXiMBRAeQd8PYYpJIgJETXkMBBPNRtMta/ajc8BoLICLzwpuBloEFWoB5lkBKSXgdBBApyfDbzBESqBEgUOsX1yRX36s0vE4CCI+UwClBAnkpgWeCBKri8FZgTJDAGLAKBQKLhNdRABEQCsQIFIgJBTIECmSEAlkCBbIrJUD8IUT8SUz8ZZTsGxkvUSX2UYIXyJP+MOchSMD7U4A+JOaFhi3YVvCVciVe6nmJiIEFonP7QuulyblQNmJjC/gDrUXRTIA1SHPXv2iHOggMdW6vh5adEQRn/RMYBQZLhxdI7BE7YhIN+WiNhnx4hscuZnKJ3QcaGASaaMzKXjgo7MUPuuPAk0qD7oQmg25x7VwfU/fd+i6/1eBB4VaDk/Hrjfu9qMNWg5XZ7GGE+gKzNbaJN5VZRgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM30);
export default __webpack_public_path__ + "static/media/m30.25f1e86fbf1178d6c1f48a88021549e3.svg";
export { ForwardRef as ReactComponent };